<!-- <ng-container *ngIf="minute < 10">0</ng-container>  -->
{{minuteForShow}}:{{secondsForShow}}